import { api } from './api.util';

export const checkMaterialPurchase = async (materialId) => {
  try {
    const response = await api.get(`/purchases/check-material/${materialId}`);
    return response;
  } catch (error) {
    console.error('Error checking material purchase:', error);
    throw error;
  }
};

export const getMaterialPurchaseInfo = async (materialId) => {
  try {
    const response = await api.get(`/purchases/material-info/${materialId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting material purchase info:', error);
    throw error;
  }
};

export const getMyPurchasedMaterials = async () => {
  try {
    const response = await api.get('/purchases/my-materials');
    return response.data;
  } catch (error) {
    console.error('Error getting purchased materials:', error);
    throw error;
  }
};

export const createMaterialPurchaseOrder = async (materialId) => {
  try {
    const response = await api.post(`/purchases/create-order-material/${materialId}`, {});
    return response;
  } catch (error) {
    console.error('Error creating material purchase order:', error);
    throw error;
  }
};

export const purchaseMaterial = async (materialId, paymentDetails) => {
  try {
    const response = await api.post(`/purchases/buy-material/${materialId}`, {
      razorpay_order_id: paymentDetails.razorpay_order_id,
      razorpay_payment_id: paymentDetails.razorpay_payment_id,
      razorpay_signature: paymentDetails.razorpay_signature
    });
    return response;
  } catch (error) {
    console.error('Error purchasing material:', error);
    throw error;
  }
};
